import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import CardActions from "@material-ui/core/CardActions";

const useStyles = makeStyles(() => ({
  root: {
    background: "white",
    borderRadius: "0",
    border: "none",
    marginTop: "10%",
    marginBottom: "13%",
    height: 508,
  },
  bottom: {
    justifyContent: "left",
    background: "#3F51B5",
  },
  links: {
    color: "white",
  },
}));

export default function About2() {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardContent>
        <Typography variant="body2">
          <CardActions disableSpacing className={classes.bottom}>
            <h2 className={classes.links}>About Me</h2>
          </CardActions>
          I've spent over 10 years working in the casino industry and recently
          decieded I needed a change. That change has lead me to pursue a career
          in sofware development. I am currently attending a full stack web
          development boot camp given at UPenn.
          <br />
          <br />
          It has been a challenging experience to say the least. That being said
          it has also been very rewarding. It is amazing how much you can learn
          in a short period of time. I am always looking to challenge myself in
          new ways and have meaningful experiences.
          <br />
          <br />
        </Typography>
      </CardContent>
    </Card>
  );
}
